import { Component, Injector } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';
import { StringUtils } from '@shared/helpers/StringUtils';
import { cpf } from 'cpf-cnpj-validator';

@Component({
  selector: 'verificar-cadastro-paciente',
  templateUrl: './verificar-cadastro-paciente.component.html',
  styleUrls: ['./verificar-cadastro-paciente.component.scss']
})
export class VerificarCadastroPacienteComponent extends AppComponentBase {
  protected ehEstrangeiro: boolean = false;
  protected cpfOrPassaporte: string;

  constructor(
    injector: Injector,
  ) {
    super(injector)
  }

  protected updateEhEstrangeiro(value: boolean): void {
    this.ehEstrangeiro = value;
    this.cpfOrPassaporte = "";
  }

  public getDados() {
    return {
      ehEstrangeiro: this.ehEstrangeiro,
      cpfOrPassaporte: this.cpfOrPassaporte
    }
  }

  public isValided(): boolean {
    return this.showErros([
      { condition: StringUtils.isNullOrEmpty(this.cpfOrPassaporte), message: "Informe o CPF ou o passaporte!" },
      { condition: !this.ehEstrangeiro && !cpf.isValid(StringUtils.onlyNumbers(this.cpfOrPassaporte)), message: "CPF inválido." },
    ]);
  }

  private showErros(validations) {
    for (const validation of validations) {
      if (validation.condition) {
        this.notify.warn(this.l(validation.message));
        return false;
      }
    }

    return true;
  }
}
